import React from 'react'
import CopyToClipboard from '../../../../utils/copy-to-clipboard'

const AuthCode = ({ value }) => {
  return <CopyToClipboard text={value}>{value}</CopyToClipboard>
}
export default AuthCode
